"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ImageBanner;
const react_1 = __importDefault(require("react"));
const ImageBanner_module_scss_1 = __importDefault(require("./ImageBanner.module.scss"));
const buildImageUrl_1 = require("../../../utils/buildImageUrl");
function ImageBanner({ logoImage, logoAccessibilityText, mobileImage, tabletImage, desktopImage, accessibilityText, }) {
    // Each range uses the upload closest to the box shape, and wid is 2x the
    // widest box in the range.
    const sources = [
        // 1488-1808 x 300: ratio 4.96-6.03
        {
            testId: "desktop-wide",
            minWidth: 1600,
            src: (0, buildImageUrl_1.buildImageUrl)(desktopImage, { fmt: "auto", wid: "3620" }),
        },
        // 1168-1487 x 300: ratio 3.89-4.96
        {
            testId: "desktop",
            minWidth: 1280,
            src: (0, buildImageUrl_1.buildImageUrl)(desktopImage, { fmt: "auto", wid: "2980" }),
        },
        // 852-1231 x 191: ratio 4.46-6.45
        {
            testId: "tablet-wide",
            minWidth: 900,
            src: (0, buildImageUrl_1.buildImageUrl)(desktopImage, { fmt: "auto", wid: "2470" }),
        },
        // 552-851 x 191: ratio 2.89-4.46
        {
            testId: "tablet",
            minWidth: 600,
            src: (0, buildImageUrl_1.buildImageUrl)(tabletImage, { fmt: "auto", wid: "1710" }),
        },
        // 448-567 x 175: ratio 2.56-3.24
        {
            testId: "mobile-wide",
            minWidth: 480,
            src: (0, buildImageUrl_1.buildImageUrl)(tabletImage, { fmt: "auto", wid: "1140" }),
        },
    ];
    // 288-447 x 175: ratio 1.65-2.55
    const mobileSrc = (0, buildImageUrl_1.buildImageUrl)(mobileImage, { fmt: "auto", wid: "900" });
    return (react_1.default.createElement("div", { className: ImageBanner_module_scss_1.default.banner, "data-testid": "adtech-banner-esi" },
        react_1.default.createElement("div", { className: ImageBanner_module_scss_1.default.container, "data-testid": "adtech-banner-container" },
            (logoImage === null || logoImage === void 0 ? void 0 : logoImage.length) > 0 && (react_1.default.createElement("img", { "data-testid": "adtech-banner-logo", src: logoImage, className: ImageBanner_module_scss_1.default.logo, alt: logoAccessibilityText })),
            react_1.default.createElement("picture", null,
                sources.map(({ testId, minWidth, src }) => (react_1.default.createElement("source", { key: testId, "data-testid": `adtech-banner-src-${testId}`, media: `(min-width: ${minWidth}px)`, srcSet: src }))),
                react_1.default.createElement("img", { "data-testid": "adtech-banner-image", src: mobileSrc, className: ImageBanner_module_scss_1.default.image, alt: accessibilityText })))));
}
